import { Button, Modal } from 'is24-corecss';
import React, { useEffect, useState } from 'react';
import { createTeam } from '../../api/TeamApi';
import { baseDomain } from '../../common/config';
import { reportViewEvent } from '../../tracking/tracking';

interface ConsentDialogProps {
  initialized: boolean;
  onSubmitted: () => void;
}

const ConsentDialog: React.FC<ConsentDialogProps> = ({ onSubmitted, initialized }: ConsentDialogProps) => {
  useEffect(() => {
    !initialized &&
      reportViewEvent({
        pageTitle: 'welcome',
      });
  }, []);

  const [modalVisible, setModalVisible] = useState(true);
  const [error, setError] = useState(null);
  const closeModal = () => {
    setModalVisible(false);
  };
  const onOkClickHandler = () => {
    createTeam()
      .then(onSubmitted)
      .catch((e) => setError(e))
      .finally(() => closeModal());
  };
  const onCancelClickHandler = () => {
    closeModal();
    location.assign(`https://${baseDomain()}/geschlossenerbereich/start.html`);
  };
  if (error) {
    throw error;
  }
  return (
    <Modal onClose={onCancelClickHandler} visible={modalVisible} title={<p className='font-h3'>Herzlich Willkommen im Teammanagement</p>}>
      <div data-testid='consent-dialog'>
        <p className='font-s'>
          Die Sicherheit Ihrer Daten hat Priorität. Jeder Mitarbeiter sollte sich daher eigene Zugangsdaten für dasselbe ImmoScout24 Kundenkonto
          anlegen.
        </p>
        <p className='font-s font-bold margin-top-m'>
          Mit dem Teammanagement legen Sie die zusätzlichen Personen an, die Zugang zu Ihrem Kundenkonto haben sollen.
        </p>
        <p className='font-s'>Sie selbst können weiterhin Ihre eigenen Zugangsdaten nutzen.</p>
        <p className='margin-top-m font-s'>
          Mit dem Klick auf &quot;Mein Team anlegen&quot; bestätigen Sie automatisch die{' '}
          <a href={`https://www.${baseDomain()}/agb/teammanagement.html`} target='_blank' rel='noreferrer'>
            Nutzungsbedingungen
          </a>
          .
        </p>
        <div className='margin-top-xl margin-bottom-xl grid grid-flex grid-justify-space-between'>
          <Button size='medium' data-testid='cancel-button' onClick={onCancelClickHandler}>
            Nein, danke.
          </Button>

          <div className='palm-one-whole margin-top-l desk-hide lap-hide' />

          <Button appearance='primary' size='medium' data-testid='ok-button' onClick={onOkClickHandler}>
            Mein Team anlegen
          </Button>
        </div>
        <p className='font-hint font-bold'>Sie haben Fragen? Kontaktieren Sie uns gern</p>
        <p className='font-hint'>
          +49 30 24301 1900 oder per E-Mail an <a href={'mailto:sicherheit@scout24.com'}>sicherheit@scout24.com</a>
        </p>
      </div>
    </Modal>
  );
};

export default ConsentDialog;
